module.exports = __webpack_public_path__ + "assets/urg.2cbaabe2.svg";